<template>
  <div class="container">
    <div class="header">
      <div class="dw_time">
        <div class="txt">截至<span>{{nowTime}}</span>，展会已报名<span class="num">{{allUnitNum}}</span>家单位</div>
        <div class="butt_box">
          <div class="distribution" @click="toDistribution" v-if="!isDistributioned"></div>
          <div class="distributioned" v-else></div>
        </div>
      </div>
    </div>
    <div class="table_box">
      <div class="table_tit">摇号结果</div>
      <el-table border id="table" class="tableStyle" element-loading-text="摇号中" empty-text="请等待摇号结果" v-loading="loading" :data="dataList" :height="442" :row-style="rowStyle">
        <el-table-column prop="qymc" label="公司名称" show-overflow-tooltip min-width="40%" align="center"></el-table-column>
        <el-table-column prop="lxr" label="联系人电话" show-overflow-tooltip min-width="30%" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.lxr}} {{scope.row.lxrsj}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bzczqysl" label="选展位时段" show-overflow-tooltip min-width="30%" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.kssj}}~{{scope.row.jssj}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="cur_page">
        <el-pagination 
          v-if="dataList.length > 0"
          @size-change="handleSizeChange"
          @current-change="currentPageChange" 
          :current-page="currentPage" 
          :page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total=parseInt(total)>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import paginator from '@/components/paginator'
export default {
  components: {
    paginator
  },
  data () {
    return {
      dataList: [],
      // 总条数
      total: 0,
      //显示加载中样
      loading: false,
      //当前页
      currentPage: 1,
      //分页大小
      pageSize: 10,
      // 总分页
      allPage: 0,
      //表高度变量
      tableheight: this.CONSTANT.tableheight10,
      nowTime: "",
      // 是否摇号出结果
      isDistributioned: false,
      loading: false,
      allUnitNum: 0,
      pageTimer: null,
      showButt: false
    }
  },
  created () {
    this.getNowTime()
    this.getNums()
    this.getDataList()
  },
  watch: {
    pageSize: {
      handler (val, oldVal) {
        this.currentPage = 1
      }
    },
    currentPage: {
      handler (val, oldVal) {
        this.getDataList()
      }
    }
  },
  beforeDestroy () {
    if (this.pageTimer) {
      clearTimeout(this.pageTimer)
    }
  },
  methods: {
    // 获取数量
    getNums () {
      this.$axios.post("qyjbxx/selectZsbmnumLsdwnumCount", {}).then(res => {
        if (res.data.code == "00000000") {
          this.allUnitNum = res.data.result.zsbmnum
        }
      })
    },
    getNowTime () {
      let date = new Date()
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      let h = date.getHours()
      m = m < 10 ? "0" + m : m
      d = d < 10 ? "0" + d : d
      this.nowTime = y + "年" + m + "月" + d + "日" + h + "时"
    },
    getDataList () {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        reserve1: 1
      }
      this.$axios.post("zwtime/doSearchListByVOTwo", param).then(res => {
        if (res.data.code === "00000000") {
          this.dataList = res.data.result.list
          if (this.dataList.length > 0) {
            this.isDistributioned = true
          }
          this.total = res.data.result.total;
          this.allPage = res.data.result.pages;
          if (this.currentPage < this.allPage) {
            if (this.pageTimer) {
              clearTimeout(this.pageTimer)
            }
            this.pageTimer = setTimeout(() => {
              this.currentPage++
            }, 5000)
          } else {
            if (this.pageTimer) {
              clearTimeout(this.pageTimer)
            }
            console.log(11);
            this.pageTimer = setTimeout(() => {
              this.currentPage = 1
            }, 5000)
          }
        }
      })
    },
    toDistribution () {
      this.loading = true
      let param = {
        reserve1: 1
      }
      this.$axios.post("zwtime/yh", param).then(res => {
        this.loading = false
        if (res.data.code === "00000000") {
          this.getDataList()
          // this.$axios.get("zwtime/sendMessage?reserve1=1").then(res => {})
        } else {
          this.$message.error("摇号失败，请稍后再试")
        }
      }).catch(err => {
        this.$message.error("摇号失败，请稍后再试")
      })
    },
    currentPageChange (val) {
      if (this.currentPage != val) {
        this.currentPage = val;
        // this.getDataList();
        if (this.pageTimer) {
          clearTimeout(this.pageTimer)
        }
      }
    },
    handleSizeChange (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        // this.getDataList();
        if (this.pageTimer) {
          clearTimeout(this.pageTimer)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    width: 100vw;
    height: 100vh;
    padding: 10px;
    background-color: #f6faff;
    .header {
      width: 100%;
      height: 260px;
      box-sizing: border-box;
      background: url(/static/images/lottery/bg_banner.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
    }
    .dw_time {
      margin-top: 36px;
      text-align: center;
      .txt {
        font-size: 26px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        &::before {
          content: "";
          display: block;
          width: 50px;
          height: 27px;
          background: url(/static/images/lottery/pic_left.png) no-repeat;
          background-size: 100% 100%;
          margin-right: 20px;
        }
        &::after {
          content: "";
          display: block;
          width: 50px;
          height: 27px;
          background: url(/static/images/lottery/pic_right.png) no-repeat;
          background-size: 100% 100%;
          margin-left: 20px;
        }
        .num {
          font-size: 36px;
          color: #fffc00;
          padding: 0 5px;
          font-family: SourceHanSansCN-Medium;
        }
      }
      .butt_box {
        margin-top: 30px;
        .distribution {
          display: inline-block;
          width: 434px;
          height: 67px;
          background: url(/static/images/lottery/btn_djyh.png) no-repeat;
          cursor: pointer;
        }
        .distributioned {
          display: inline-block;
          width: 434px;
          height: 67px;
          background: url(/static/images/lottery/btn_jgyc.png) no-repeat;
        }
      }
    }
    .table_box {
      .table_tit {
        margin: 0 auto;
        width: 240px;
        font-family: SourceHanSansCN;
        font-weight: bold;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 24px;
        color: #2452ff;
        background: url(/static/images/lottery/pic_title.png) no-repeat;
        margin-top: 40px;
        margin-bottom: 26px;
      }
      .cur_page {
        margin-top: 20px;
        display: flex;
        justify-content: center;
      }
    }

    /deep/ .el-table__empty-text {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: url(/static/images/lottery/bg_ddjg.png) no-repeat;
      background-size: 100% 100%;
      font-size: 18px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      &::before {
        content: "";
        display: inline-block;
        width: 28px;
        height: 28px;
        background: url(/static/images/lottery/icn_wait.png) no-repeat center center;
        background-size: 28px 28px;
        margin-right: 10px;
      }
    }

    /deep/ .el-table__header th, /deep/ .el-table__header tr {
      background-color: #e9eeff;
      border: none;
      border-top: 3px solid #2452ff;
      height: 41px;
      font-size: 14px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #333;
    }

    /deep/ .el-table td, /deep/ .el-table th.is-leaf {
      border-right: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/lottery/index.vue